import { DBO_REQ } from '@op/utils/format';
import { useEffect, useState } from 'react';
import { getWeeklyAccountCharts } from '@op/services';
import { TRequestBackType } from '@op/utils/requestUtil';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';

interface ApiResp {
  list: {
    key: string;
    time: string;
    val: number;
  }[];
  timeline_of_end_time: string;
  timeline_of_start_time: string;
}

interface Props {
  defaultSelectAccount: string[];
  type: string;
  metric: string;
  filter: any;
}

export function useAccountLineData({
  defaultSelectAccount,
  type,
  metric,
  filter,
}: Props) {
  const { wrapperCancelRequest, loading } = useCancelRequestHook({});

  // 官号筛选器
  const [selectAccounts, setSelectedAccounts] = useState(defaultSelectAccount);
  const [chartsData, setChartsData] = useState<TRequestBackType>({});

  useEffect(() => {
    if (!filter) return;

    getAccountLineChartData();
  }, [selectAccounts, type, metric, filter]);

  useEffect(() => {
    if (defaultSelectAccount.length !== 0) {
      setSelectedAccounts(defaultSelectAccount);
    }
  }, [defaultSelectAccount]);

  function getAccountLineChartData() {
    const realSelectAccounts =
      selectAccounts.length === defaultSelectAccount.length
        ? []
        : selectAccounts;
    wrapperCancelRequest(getWeeklyAccountCharts, {
      ...filter,
      social_media_by_account: realSelectAccounts,
      group_by: type,
      metric,
    })
      .then((data: ApiResp) => {
        const { timeline_of_start_time, timeline_of_end_time, list } =
          data || {};
        if (!list || list.length === 0) {
          setChartsData({ isEmpty: true });
          return;
        }

        const info = DBO_REQ.listKeys(
          {
            timeline: list,
            valueKey: 'val',
          },
          {
            timeline_of_start_time,
            timeline_of_end_time,
            filter: { date_type: 'weekly' },
          },
        );
        setChartsData(info);
      })
      .catch(() => {});
  }

  return { chartsData, loading, selectAccounts, setSelectedAccounts };
}
